module.exports = __webpack_public_path__ + "img/snb-dgjg.0b5fbac7.svg";